/**
 * クローンしたフィールドグループの name / id / for / ラベル番号を
 * 新しいインデックスに書き換える
 */
const updateCloneIndices = (clone, prefix, newIndex) => {
    /**
     * 丸数字に変換（①②③...⑳、それ以降は (21) 形式）
     */
    const toCircledNumber = (number) => {
        const characters = '①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳';
        return characters[number] ?? `(${number + 1})`;
    };

    const oldBracket = `${prefix}[0]`;
    const newBracket = `${prefix}[${newIndex}]`;
    const oldUnderscore = `${prefix}_0_`;
    const newUnderscore = `${prefix}_${newIndex}_`;

    clone.dataset.index = String(newIndex);

    // input / select / textarea の name, id を更新
    clone.querySelectorAll('input, select, textarea').forEach(element => {
        if (element.name) {
            element.name = element.name.replace(oldBracket, newBracket);
        }
        if (element.id) {
            element.id = element.id.replace(oldUnderscore, newUnderscore);
        }
    });

    // label の for 属性を更新
    clone.querySelectorAll('label[for]').forEach(label => {
        label.setAttribute(
            'for',
            label.getAttribute('for').replace(oldUnderscore, newUnderscore),
        );
    });

    // ラベルテキスト内の丸数字を更新（① → 新しい番号）
    clone.querySelectorAll('.c-forms-row__label').forEach(label => {
        label.textContent = label.textContent.replace('①', toCircledNumber(newIndex));
    });
};

/**
 * クローンしたフィールドグループの入力値・必須マーク・エラー状態をリセットする
 */
const resetCloneState = (clone) => {
    /**
     * セレクト要素の空値チェックとイベントリスナーを設定
     * cloneNode はイベントリスナーをコピーしないため再設定が必要
     */
    const setupSelectListener = (select) => {
        const checkEmptyValue = () => {
            if (select.value === '') {
                select.setAttribute('data-no-value', '');
            } else {
                select.removeAttribute('data-no-value');
            }
        };
        checkEmptyValue();
        select.addEventListener('change', checkEmptyValue);
    };

    // 入力値をクリアし、エラー状態をリセット
    clone.querySelectorAll('input, select, textarea').forEach(element => {
        if (element.tagName === 'TEXTAREA') {
            element.value = '';
            element.textContent = '';
        } else if (element.tagName === 'SELECT') {
            element.selectedIndex = 0;
            setupSelectListener(element);
        } else {
            element.value = '';
        }
        element.classList.remove('_invalid');
    });

    // 追加グループからは必須マークと required 属性を外す
    clone.querySelectorAll('.c-forms-row__required').forEach(element => element.remove());
    clone.querySelectorAll('[required]').forEach(element => element.removeAttribute('required'));

    // エラーメッセージを削除
    clone.querySelectorAll(
        '.c-forms-input-text__error, .c-forms-input-select__error, .c-forms-input-textarea__error',
    ).forEach(element => element.remove());
};

/**
 * 中途エントリーフォーム：フィールドグループの動的追加
 *
 * 追加ボタンをクリックすると、対応する data-field-container 内の
 * 最初の __field-group をテンプレートとしてクローンし、
 * インデックスやラベル番号を更新した上でコンテナ末尾に追加する。
 */
const entry = () => {
    if (document.getElementById('page-recruit') === null) return;

    const page = document.querySelector('.pg-content-entry');
    if (!page) return;

    const MAX_FIELD_GROUPS = 20;

    page.querySelectorAll('.pg-content-entry__add-btn').forEach(button => {
        button.addEventListener('click', () => {
            const section = button.closest('.pg-content-entry__section');
            const container = section.querySelector('[data-field-container]');
            if (!container) return;

            const fieldGroups = container.querySelectorAll('.pg-content-entry__field-group');
            const template = fieldGroups[0];
            const newIndex = fieldGroups.length;
            const prefix = container.dataset.fieldContainer;

            // テンプレート（最初のグループ）をクローン
            const clone = template.cloneNode(true);
            updateCloneIndices(clone, prefix, newIndex);
            resetCloneState(clone);

            container.appendChild(clone);

            // 上限に達したらボタンを非表示
            if (newIndex + 1 >= MAX_FIELD_GROUPS) {
                button.style.display = 'none';
            }
        });

        // 初期表示時に既に上限の場合もボタンを非表示
        const section = button.closest('.pg-content-entry__section');
        const container = section?.querySelector('[data-field-container]');
        if (container) {
            const count = container.querySelectorAll('.pg-content-entry__field-group').length;
            if (count >= MAX_FIELD_GROUPS) {
                button.style.display = 'none';
            }
        }
    });
};

export default entry;
